import React from 'react';
import { Download, FileText } from 'lucide-react';

interface FileAttachmentProps {
  fileName: string;
  fileUrl: string;
  fileSize?: number;
  fileType?: string;
}

const FileAttachment: React.FC<FileAttachmentProps> = ({
  fileName,
  fileUrl,
  fileSize,
  fileType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}) => {
  const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = fileUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };


  return (
    <div className="mt-3 p-4 bg-teal-50 border border-teal-200 rounded-lg">
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0">
          <FileText className="w-8 h-8 text-teal-600" />
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {fileName}
          </p>
          {fileSize && (
            <p className="text-xs text-gray-500">
              {formatFileSize(fileSize)}
            </p>
          )}
        </div>
        
        <div className="flex gap-2">
          <button
            onClick={handleDownload}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-teal-600 rounded-md hover:bg-teal-700 transition-colors"
            title="Télécharger le fichier"
          >
            <Download className="w-3 h-3" />
            Télécharger
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileAttachment;
